import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserResetSettingsSSO, saveUserResetSettingsSSO} from 'src/openapi/admin/apis/AccountSingleSignOnApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SsoUserResetSettings} from 'src/openapi/admin/models/SsoUserResetSettings';

type Props = {
    accountId: number,
};

export const useResetDateSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(
        (signal: AbortSignal) => apiDispatch(getUserResetSettingsSSO({accountId}, {signal})),
        [accountId, apiDispatch],
    );

    const saveDispatchAction = useCallback(
        (ssoUserResetSettings: SsoUserResetSettings, signal: AbortSignal) =>
            apiDispatch(saveUserResetSettingsSSO({accountId, ssoUserResetSettings}, {signal})),
        [accountId, apiDispatch],
    );

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {},
    });
};
